import React, { Component } from 'react';
import df from 'dateformat';
import {
  List,
  Badge,
  Button,
  Calendar,
  DatePicker,
  InputItem, Modal,
  NavBar,
  Stepper,
  Toast,
  WhiteSpace,
  WingBlank,
  Checkbox
} from 'antd-mobile';
import CustomerInput from '../../../components/CustomerInput';
import InputNumber from '../../../components/InputNumber';
import Folding from '../../../components/folding';
import translate from '../../../utils/translate';
import BreederList from '../components/breeder-list';
import TrnInActivityTypeList from '../components/trnInActivityType-list';
import ActivityTypeList from '../components/activityType-list';
import MateGroupList from '../components/mateGroup-list';
import ReleaseFarmOrgList from '../components/releaseFarmOrg-list';
import AtBirthFarmOrgList from '../components/atbirthFarmOrg';
import LastActivityTypeList from '../components/lastActivityType-list';
import TransferInOutOrgCodeList from '../components/transferInOutOrgCode-list';
import TransferInOutFarmOrgList from '../components/transferInOutFarmOrg-list';
import SwineDamOrSireList from '../components/swineDamOrSire-list';
import auth from '../../../utils/auth';
import send_init from '../../../utils/send_init';
import {ROOT_PATH} from '../../../config';
import FarmOrgList from '../components/farmOrg-list';

let FARM_ORG = auth.readCookie('FARMORG') + '-0-0';
let ORG_CODE = auth.readCookie('ORGCODE');
const today = new Date();
const firstDay = new Date().setDate(1);
console.log(firstDay);
let mateGroupSource = [];
export default class Boar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMore: false, // 默认不展开
      showDot: false, // 更多里面的必填项是否显示必填
      saveAble: true,
      hasMore: true,
      swineIdErr: false,
      date: new Date(firstDay), // 单据日期， 不存，选择后，date=转正日期 = 调拨进日期
      size: 20,
      sumCount: 0,
      sumPage: 0,
      dateSaveTodate: df(today, 'yyyy/mm/dd'),
      isShow: false,
      refreshing: false,
      modalContent: null,
      farmOrgLoc: '',
      breederDesc: '',
      transferInOrgCodeDesc: ORG_CODE,
      transferInFarmOrgDesc: '',
      visibleCalendar: false
    };
    this.state.cache = {
      farmOrg: '',
      activityDate: df(new Date(), 'yyyy-mm-dd'),
      activityType: 'G', // G : litno1，litno2  = 0 ,不可修改。
      atbirthFarmOrgLoc: '',
      birthDate: '',
      birthWeek: '',
      breeder: '',
      genFlg: '',
      lastActivityDate: '',
      lastActivityType: '',
      lastLitno1: '0',
      lastLitno2: '0',
      lastMateGroup: '',
      litno1: '0',
      litno2: '0',
      mateGroup: '',
      releaseFarmOrgLoc: '',
      replaceDate: df(new Date(firstDay),'yyyy-mm-dd'), //df(this.state.date,'yyyy-mm-dd')
      replaceLitno1: '0',
      replaceLitno2: '0',
      replaceMateGroup: '',
      sex: 'M',
      swineDamDateIn: '',
      swineDamId: '0000',  // 给父母系默认初始信息。 at 2019-8-12
      swineDamTrack: '99-2-0000-0000',// 给父母系默认初始信息。at 2019-8-12
      swineDateIn: '',
      swineId: '',
      swineSirDateIn: '',
      swineSirId: '0000',// 给父母系默认初始信息。at 2019-8-12
      swineSirTrack: '99-1-0000-0000',// 给父母系默认初始信息。at 2019-8-12
      swineTrack: '',
      transferFlg: '',
      transferInDate: df(new Date(firstDay),'yyyy-mm-dd'), //df(this.state.date,'yyyy-mm-dd')
      transferInFarmOrg: '',
      transferInOrgCode: ORG_CODE,
      transferOutDate: '',
      transferOutFarmOrg: '',
      transferOutOrgCode: '',
      trnInActivityDate: df(new Date(), 'yyyy-mm-dd'),
      trnInActivityType: 'G',
      trnInLitno1: '0',
      trnInLitno2: '0',
      trnInMateGroup: '',
      verBreederFarmOrg: '',
      weight: 0
    };
    this.initDate = {
      state:  {
        showDot: false, // 更多里面的必填项是否显示必填
        saveAble: true,
        hasMore: true,
        swineIdErr: false,
        date: new Date(firstDay), // 单据日期， 不存，选择后，date=转正日期 = 调拨进日期
        size: 20,
        sumCount: 0,
        sumPage: 0,
        dateSaveTodate: df(today, 'yyyy/mm/dd'),
        isShow: false,
        refreshing: false,
        modalContent: null,
        farmOrgLoc: '',
        breederDesc: '',
        transferInOrgCodeDesc: auth.readCookie('ORGCODE'),
        transferInFarmOrgDesc: '',
        visibleCalendar: false
      },
      cache: {
        farmOrg: '',
        activityDate: df(new Date(), 'yyyy-mm-dd'),
        activityType: 'G', // G : litno1，litno2  = 0 ,不可修改。
        atbirthFarmOrgLoc: '',
        birthDate: '',
        birthWeek: '',
        breeder: '',
        genFlg: '',
        lastActivityDate: '',
        lastActivityType: '',
        lastLitno1: '0',
        lastLitno2: '0',
        lastMateGroup: '',
        litno1: '0',
        litno2: '0',
        mateGroup: '',
        releaseFarmOrgLoc: '',
        replaceDate: df(new Date(firstDay),'yyyy-mm-dd'), //df(this.state.date,'yyyy-mm-dd')
        replaceLitno1: '0',
        replaceLitno2: '0',
        replaceMateGroup: '',
        sex: 'M',
        swineDamDateIn: '',
        swineDamId: '0000',  // 给父母系默认初始信息。 at 2019-8-12
        swineDamTrack: '99-2-0000-0000',// 给父母系默认初始信息。at 2019-8-12
        swineDateIn: '',
        swineId: '',
        swineSirDateIn: '',
        swineSirId: '0000',// 给父母系默认初始信息。at 2019-8-12
        swineSirTrack: '99-1-0000-0000',// 给父母系默认初始信息。at 2019-8-12
        swineTrack: '',
        transferFlg: '',
        transferInDate: df(new Date(firstDay),'yyyy-mm-dd'), //df(this.state.date,'yyyy-mm-dd')
        transferInFarmOrg: '',
        transferInOrgCode: auth.readCookie('ORGCODE'),
        transferOutDate: '',
        transferOutFarmOrg: '',
        transferOutOrgCode: '',
        trnInActivityDate: df(new Date(), 'yyyy-mm-dd'),
        trnInActivityType: 'G',
        trnInLitno1: '0',
        trnInLitno2: '0',
        trnInMateGroup: '',
        verBreederFarmOrg: '',
        weight: 0
      }
    }
  }
  initState = () => {
    this.setState(state => {
      state.cache.swineId = '';
      return state;
    })
    // this.setState({
    //   ...this.initDate.state,
    //   cache: {...this.initDate.cache}
    // });
    // this.doGetFarmOrg(); // 默认农场
    // this.getTranInFarmOrg(ORG_CODE, 'G');
    // this.getReleaseFarmOrg('G');
  };
  componentWillUnmount() {
    this.setState = () => false
  }
  UNSAFE_componentWillMount() {
    ORG_CODE = auth.readCookie('ORGCODE');
    FARM_ORG = auth.readCookie('FARMORG')+ '-0-0';
    this.setState(state => {
      state.transferInOrgCodeDesc = ORG_CODE;
      state.cache.transferInOrgCode = ORG_CODE;
      return state
    })
  }
  componentDidMount() {
    console.log(12);
    this.doGetFarmOrg(); // 默认农场
    this.getTranInFarmOrg(ORG_CODE, 'G');
    this.getReleaseFarmOrg('G');
  }
  doGetFarmOrg = () => {
    send_init({
      url: `${ROOT_PATH}/api/ifarm/v1/genealogy/farm_org?project=SW`,
      method: 'GET'
    })
      .then(res => {
        let data = res.data;
        let index = null; // 161322001 432506-0-0 农场没有
        data.length > 0 &&
        data.forEach((o, i) => {
          o.farmOrg === FARM_ORG && (index = i)
        });
        index !== null &&
        this.setState(state => {
          state.cache.farmOrg = data[index].farmOrg;
          state.farmOrgLoc = data[index].nameLoc;
          return state
        })
      })
  };
  getTranInFarmOrg = (orgCode, activityType) => {
    // console.log('EE', this.state.releaseFarms)
    send_init({
      url: `${ROOT_PATH}/api/ifarm/v1/genealogy/inorout_farm_org`,
      method: 'POST',
      data: {
        inOrOutOrgCode: orgCode,
        page: {
          currentPage: 1,
          size: 100
        },
        queryValue: ''
      }
    })
      .then(res => {
        if (res.data.statusCode === '500') {
        } else {
          const farms = res.data.list;
          // 找到第一个 6舍
          let item6 =
            farms.find(item => {
              let farmOrgs = item.farmOrg.split('-');
              let location = farmOrgs[farmOrgs.length - 2];
              return location === '6'
            }) || {};
          // 找到第一个 1舍
          let item1 =
            farms.find(item => {
              let farmOrgs = item.farmOrg.split('-');
              let location = farmOrgs[farmOrgs.length - 2];
              return location === '1'
            }) || {};
          // 根据当前状态来取值 调拨进的农场，G状态 默认 6舍，其他默认 1舍
          if (activityType === 'G') {
            this.setState(state => {
              state.cache.transferInFarmOrg = item6.farmOrg;
              state.transferInFarmOrgDesc = item6.nameLoc;
              return state
            })
          } else {
            this.setState(state => {
              state.cache.transferInFarmOrg = item1.farmOrg;
              state.transferInFarmOrgDesc = item1.nameLoc;
              return state
            })
          }
        }
      })
  };
  getReleaseFarmOrg = activityType => {
    send_init({
      url: `${ROOT_PATH}/api/ifarm/v1/genealogy/release_farm?activityType=${activityType}`,
      method: 'GET'
    })
      .then(res => {
        let item6 = res.data.find(obj => obj.location === '6') || {};
        let item1 = res.data.find(obj => obj.location === '1') || {};
        if (activityType === 'G') {
          this.setState(state => {
            state.cache.releaseFarmOrgLoc = item6.farmOrg;
            state.releaseLocation = item6.location;
            return state
          })
        } else {
          this.setState(state => {
            state.cache.releaseFarmOrgLoc = item1.farmOrg;
            state.releaseLocation = item1.location;
            return state
          })
        }
      })
  };
  doGetMateGroup = (dateType, d) => {
    const _self = this;
    const date = df(d, 'yyyy-mm-dd');
    send_init({
      url: `${ROOT_PATH}/api/ifarm/v1/swine/mate_groups?Date=${date}`,
      method: 'GET'
    })
      .then(res => {
        let data = res.data;
        data.length === 0 ? (data = [{ mateGroup: '1903' }]) : (data = res.data);
        _self.setState(state => {
          state.cache[dateType] = data[0].mateGroup;
          state.sumCount = res.data.length;
          state.hasMore = res.data.length !== 0;
          return state
        })
      })
  };
  doSaveCheck = data => {
    let err = 0;
    if (!data.swineId) {
      err++;
      Toast.info('请输入 猪只耳号', 2.5)
    } else if (this.state.swineIdErr) {
      err++;
      Toast.info('猪只耳号只能输入4 - 6位', 2.5)
    } else if (!data.birthWeek || !data.birthDate) {
      err++;
      Toast.info('请选择 出生日期', 2.5)
    } else if (!data.weight * 1) {
      err++;
      Toast.info('重量必填，且必须大于0', 2.5)
    } else if (!data.breeder) {
      err++;
      Toast.info('请选择 品种', 2.5)
    } else if (!data.trnInActivityType) {
      err++;
      Toast.info('请选择 当前状态', 2.5)
    } else if (!data.trnInActivityDate) {
      err++;
      Toast.info('请选择 当前状态日期', 2.5)
    } else if (!data.releaseFarmOrgLoc) {
      err++;
      Toast.info('请选择 原始信息所在农场', 2.5)
    } else if (!data.activityDate) {
      err++;
      Toast.info('请选择 原始信息日期', 2.5)
    } else if (!data.transferInOrgCode) {
      err++;
      Toast.info('请选择 调拨分公司', 2.5)
    } else if (!data.transferInDate) {
      err++;
      Toast.info('请选择 调拨日期', 2.5)
    } else if (!data.transferInFarmOrg) {
      err++;
      Toast.info('请选择 调拨农场', 2.5)
    } else if (this.state.releaseLocation === '1' && !data.replaceDate) {
      err++;
      Toast.info('请选择 转正日期', 2.5)
    }

    return err === 0
  };
  doSave = data => {
    this.doSaveCheck(data) && this.doSaveAfterCheck(data)
  };
  doSaveAfterCheck = data => {
    if (!this.state.saveAble) {
      return
    }
    // 存入本地
    let SWINE = auth.readCookie('swineReq') || [];
    // 如果猪只重复了，就不要存
    const sexNum = data.sex === 'M'? 1 : 2;
    const swineTrack = `${data.breeder}-${sexNum}-${data.birthWeek}-${data.swineId}`;
    let flag = SWINE.some(o => {
      const num = o.sex === 'M'? 1 : 2;
      const track = `${o.breeder}-${num}-${o.birthWeek}-${o.swineId}`;
      return track === swineTrack
    });
    if (flag) {
      Toast.info('猪只重复', 1);
      return
    }
    SWINE.push(data);
    auth.setCookie('swineReq', SWINE);
    Toast.success('添加成功', 1, () => {
      //  初始化界面的值
      this.initState()
    })
  };
  forMatSwine = value => {
    if (value.length === 0) {
      return ''
    } else if (value.length === 1) {
      return '000' + value
    } else if (value.length === 2) {
      return '00' + value
    } else if (value.length === 3) {
      return '0' + value
    } else {
      return value
    }
  };
  toggleCalendar=()=>{
    this.setState({
      visibleCalendar: !this.state.visibleCalendar
    })
  };
  precisionFormat = (val ,precision,length) => {
    val = val + '';
    if (length){
      // 截取对应的位数。
      val = val.substr(0,length)
    }
    if (precision && val.indexOf('.') !== -1) {
      let vals = val.split('.');
      let head = vals[0];
      let tail = vals[1];
      if (tail.length > precision) {
        tail = tail.substring(0, precision)
      }
      return head + '.' + tail
    } else {
      return val.split('.')[0]
    }
  };
  render() {
    const { cache } = this.state;
    let sexCode = cache.sex === 'F' ? '2': '1';
    mateGroupSource = this.props.mateGroupSource || [];
    const swineTrack = `${this.state.cache.breeder}-${sexCode}-${this.state.cache.birthWeek}-${this.state.cache.swineId}`;
    return (
      <React.Fragment>
        <List>
          <DatePicker
              mode="date"
              maxDate={new Date()}
              minDate={new Date(auth.getMinDate())}
              value={this.state.date}
              onOk={date => {
              this.setState(state => {
                state.date = date;
                state.cache.transferInDate = df(date, 'yyyy-mm-dd');
                state.cache.replaceDate = df(date, 'yyyy-mm-dd');
                return state
              })
            }}
          >
            <List.Item
                arrow="horizontal"
                className={
                this.state.date
                  ? 'span-4'
                  : 'span-4 am-list-extra-empty'
              }
            >
              单据日期
            </List.Item>
          </DatePicker>
          <List.Item
              className={
              this.state.farmOrgLoc ? 'span-4' : 'span-4 am-list-extra-empty'
            }
              extra={this.state.farmOrgLoc || '请选择'}
              arrow="horizontal"
              onClick={() => {
              this.setState(state => {
                state.modalShow = true;
                state.modalContent = (
                  <FarmOrgList
                      current={this.state.cache.farmOrg}
                      selectItem={item => {
                      this.setState(state => {
                        state.modalShow = false;
                        state.farmOrgLoc = item.nameLoc;
                        state.cache.farmOrg = item.farmOrg;
                        return state
                      })
                    }}
                  />
                );
                return state
              })
            }}
          >
            农场代码 <Badge dot />
          </List.Item>
          <CustomerInput
              type="digit"
              clear
              placeholder="请输入猪只耳号"
              maxLength={6}
              pattern={'[0-9]*'}
              style={{ textAlign: 'right'}}
              error={this.state.swineIdErr}
              value={this.state.cache.swineId}
              onErrorClick={() => {
              Toast.info('耳号必填，且小于6位', 2)
            }}
              onChange={v => {
              this.setState(state => {
                state.cache.swineId = this.precisionFormat(v,0,6);
                state.swineIdErr = v.length > 6;
                return state
              })
            }}
              onBlur={v => {
              this.setState(state => {
                state.cache.swineId = this.forMatSwine(this.precisionFormat(v,0,6));
                return state
              })
            }}
          >
            猪只耳号 <Badge dot />
          </CustomerInput>
          <List.Item
              disabled
              extra={swineTrack}
          >
            猪只编码
          </List.Item>
        </List>
        <List renderHeader={() => ''}>
          <List.Item>
            <b>基本信息</b>
          </List.Item>
          <List.Item
              extra={
              <div>
                <Button
                    inline
                    size="small"
                    type={this.state.cache.sex === 'F' ? 'ghost' : ''}
                    style={{ marginRight: '4px' }}
                    onClick={() => { this.setState(state => {
                    state.cache.sex = 'F';
                    return state
                  })
                  }}

                >
                  母
                </Button>
                <Button
                    inline
                    size="small"
                    type={this.state.cache.sex === 'M' ? 'ghost' : ''}
                    onClick={() => {
                    this.setState(state => {
                      state.cache.sex = 'M';
                      return state
                    })
                  }}
                >
                  公
                </Button>
              </div>
            }
          >
            性别 <Badge dot />
          </List.Item>
          <List.Item
              className={
              this.state.breederDesc ? 'span-4' : 'span-4 am-list-extra-empty'
            }
              extra={this.state.breederDesc || '请选择'}
              arrow="horizontal"
            // onClick={this.getBreeder}
              onClick={() => {
              this.setState(state => {
                state.modalShow = true;
                state.modalContent = (
                  <BreederList
                      sex={this.state.cache.sex}
                      current={this.state.cache.breeder}
                      selectItem={item => {
                      this.setState(state => {
                        state.modalShow = false;
                        state.breederDesc = item.descLoc;
                        state.cache.breeder = item.breeder;
                        return state
                      })
                    }}
                  />
                );
                return state
              })
            }}
          >
            品种 <Badge dot />
          </List.Item>

          {/*出生日期*/}
          <DatePicker
              mode="date"
              value={
              this.state.cache.birthDate && new Date(this.state.cache.birthDate)
            }
              onOk={date => {
              this.doGetMateGroup('birthWeek', date);
              this.setState(state => {
                state.cache.birthDate = df(date, 'yyyy-mm-dd');
                return state
              })
            }}
          >
            <List.Item
                arrow="horizontal"
                className={
                this.state.cache.birthDate
                  ? 'span-4'
                  : 'span-4 am-list-extra-empty'
              }
            >
              出生日期 <Badge dot />
            </List.Item>
          </DatePicker>

          <List.Item
              extra={this.state.cache.birthWeek}
            // arrow="horizontal"
          >
            出生周
          </List.Item>
          <InputNumber
              extra="KG"
              type="number"
              precision={2}
              style={{ textAlign: 'right' }}
              placeholder={`${translate.zh_CN.common.defaultValue}0.00`}
              value={cache.weight || ''}
              error={this.state.weightErr}
              onErrorClick={() => {
              Toast.info('重量必填，且必须大于0')
            }}
              onChange={v => {
              this.setState(state => {
                state.cache.weight = v;
                // state.weightErr = (v*1===0)
                return state
              })
            }}
              onFocus={() => {
              if (this.state.cache.weight * 1 === 0) {
                this.setState(state => {
                  state.cache.weight = '';
                  return state
                })
              }
            }}
          >
            重量 <Badge dot />
          </InputNumber>
          {/* 以下是目前状态*/}
          <List.Item
              className={
              this.state.cache.activityType
                ? 'max-extra-width'
                : 'max-extra-width am-list-extra-empty'
            }
              extra={this.state.cache.activityType || '请选择'}
              arrow="horizontal"
            // onClick={this.changeTrnInActivityType}
              onClick={() => {
              this.setState(state => {
                state.modalShow = true;
                state.modalContent = (
                  <TrnInActivityTypeList
                      current={this.state.cache.activityType}
                      lastActivityType={state.cache.lastActivityType}
                      selectItem={item => {
                      this.getTranInFarmOrg(
                        this.state.cache.transferInOrgCode,
                        item.status
                      );
                      this.getReleaseFarmOrg(item.status);
                      this.setState(state => {
                        state.modalShow = false;
                        state.cache.activityType = item.status;
                        state.activityTypeDesc = item.descLoc;
                        // 选择当前状态后，原始状态 = 当前状态
                        state.cache.trnInActivityType = item.status;
                        state.trnInActivityTypeDesc = item.descLoc;
                        // 默认为 1 。当 当前状态为G .则为 0
                        if (item.status === 'G') {
                          state.cache.trnInLitno1 = 0;
                          state.cache.trnInLitno2 = 0;
                          state.cache.litno1 = 0;
                          state.cache.litno2 = 0;
                          state.cache.mateGroup = '';
                          state.cache.trnInMateGroup = ''
                        } else if (item.status === 'A') {
                          // 这个状态里面的值 是 5 -5 新需求加的。
                          state.cache.trnInLitno1 = 1;
                          state.cache.trnInLitno2 = 2;
                          state.cache.litno1 = 1;
                          state.cache.litno2 = 2
                        } else {
                          state.cache.trnInLitno1 = 1;
                          state.cache.trnInLitno2 = 1;
                          state.cache.litno1 = 1;
                          state.cache.litno2 = 1
                        }
                        // 当前状态为M,则根据当前状态日期 自动计算mateGroup
                        if (item.status === 'M' && state.cache.activityDate) {
                          this.doGetMateGroup(
                            'mateGroup',
                            state.cache.activityDate
                          );
                          this.doGetMateGroup(
                            'trnInMateGroup',
                            state.cache.activityDate
                          )
                        }
                        // 当前状态除了 M 其他时候都需要清空配种组
                        if (item.status !== 'M') {
                          state.cache.mateGroup = '';
                          state.cache.trnInMateGroup = ''
                        }
                        return state
                      })
                    }}
                  />
                );
                return state
              })
            }}
          >
            当前状态 <Badge dot />
          </List.Item>

          <DatePicker
              mode="date"
              value={
              this.state.cache.activityDate &&
              new Date(this.state.cache.activityDate)
            }
              onOk={date => {
              if (this.state.cache.activityType === 'M') {
                this.doGetMateGroup('mateGroup', date);
                this.doGetMateGroup('trnInMateGroup', date)
              }
              this.setState(state => {
                state.cache.activityDate = df(date, 'yyyy-mm-dd');
                state.cache.trnInActivityDate = df(date, 'yyyy-mm-dd');
                return state
              })
            }}
          >
            <List.Item
                arrow="horizontal"
                className={
                this.state.cache.activityDate
                  ? ''
                  : ' am-list-extra-empty'
              }
            >
              当前状态日期 <Badge dot />
            </List.Item>
          </DatePicker>

          <List.Item
              extra={
              <Stepper
                  style={{ width: '100%', minWidth: '100px' }}
                  showNumber
                  disabled={this.state.cache.activityType === 'G'}
                  min={0}
                  value={this.state.cache.litno1}
                  onChange={v => {
                  this.setState(state => {
                    state.cache.litno1 = v;
                    state.cache.trnInLitno1 = v;
                    return state
                  })
                }}
              />
            }
          >
            胎次 <Badge dot />
          </List.Item>

          <List.Item
              extra={
              <Stepper
                  style={{ width: '100%', minWidth: '100px' }}
                  showNumber
                  disabled={this.state.cache.activityType === 'G'}
                  min={0}
                  value={this.state.cache.litno2}
                  onChange={v => {
                  this.setState(state => {
                    state.cache.litno2 = v;
                    state.cache.trnInLitno2 = v;
                    return state
                  })
                }}
              />
            }
          >
            配种次数 <Badge dot />
          </List.Item>
          {
            this.state.showMore && (
              <List.Item
                  extra={<Checkbox.AgreeItem
                      checked={cache.genFlg === 'AI'}
                      onChange={()=>{
                    const checked = cache.genFlg === 'AI';
                    this.setState(state =>{
                      state.cache.genFlg = checked ? '' : 'AI';
                      return state
                    })
                  }}
                         >虚拟公猪</Checkbox.AgreeItem>}
              >
                系谱类别
              </List.Item>
            )
          }
        </List>

        <Folding onChange={showMore => {
          this.setState({showMore})
        }}
        >
          {/*<h4>原始信息</h4>*/}
          <List renderHeader={() => ''}>
            <List.Item>
              <b>原始信息</b>
            </List.Item>

            <List.Item
                className={cache.trnInActivityType ? '' : 'am-list-extra-empty'}
                extra={cache.trnInActivityType || '请选择'}
                arrow="horizontal"
                onClick={() => {
                this.setState({
                  modalShow: true,
                  modalContent: (
                    <ActivityTypeList
                        current={cache.trnInActivityType}
                        selectItem={item => {
                        this.setState(state => {
                          state.modalShow = false;
                          state.cache.trnInActivityType = item.gdCode;
                          state.trnInActivityTypeDesc = item.descLoc;
                          if (item.gdCode === 'G') {
                            state.cache.trnInLitno1 = 0;
                            state.cache.trnInLitno2 = 0;
                            state.cache.trnInMateGroup = ''
                          } else if (item.gdCode === 'A') {
                            // 5-5 新需求
                            state.cache.trnInLitno1 = 1;
                            state.cache.trnInLitno2 = 2
                          } else {
                            state.cache.trnInLitno1 = 1;
                            state.cache.trnInLitno2 = 1
                          }
                          if (
                            item.gdCode === 'M' &&
                            state.cache.trnInActivityDate
                          ) {
                            this.doGetMateGroup(
                              'trnInMateGroup',
                              state.cache.trnInActivityDate
                            )
                          }
                          //  当 状态 除了 M ,都需要清空配种组
                          if (item.status !== 'M') {
                            state.cache.trnInMateGroup = ''
                          }
                          return state
                        })
                      }}
                    />
                  )
                })
              }}
            >
              状态 {this.state.showDot && <Badge dot />}
            </List.Item>
            <DatePicker
                mode="date"
                value={
                this.state.cache.trnInActivityDate &&
                new Date(this.state.cache.trnInActivityDate)
              }
                onOk={date => {
                this.state.cache.trnInActivityType === 'M' &&
                this.doGetMateGroup('trnInMateGroup', date);
                this.setState(state => {
                  state.cache.trnInActivityDate = df(date, 'yyyy-mm-dd');
                  return state
                })
              }}
            >
              <List.Item
                  arrow="horizontal"
                  className={cache.trnInActivityDate ? '' : 'am-list-extra-empty'}
              >
                日期 {this.state.showDot && <Badge dot />}
              </List.Item>
            </DatePicker>
            <List.Item
                extra={
                <Stepper
                    style={{ width: '100%', minWidth: '100px' }}
                    showNumber
                    disabled={this.state.cache.trnInActivityType === 'G'}
                    min={0}
                    value={this.state.cache.trnInLitno1}
                    onChange={v => {
                    this.setState(state => {
                      state.cache.trnInLitno1 = v;
                      return state
                    })
                  }}
                />
              }
            >
              胎次 {this.state.showDot && <Badge dot />}
            </List.Item>
            <List.Item
                extra={
                <Stepper
                    style={{ width: '100%', minWidth: '100px' }}
                    showNumber
                    disabled={this.state.cache.trnInActivityType === 'G'}
                    min={0}
                    value={this.state.cache.trnInLitno2}
                    onChange={v => {
                    this.setState(state => {
                      state.cache.trnInLitno2 = v;
                      return state
                    })
                  }}
                />
              }
            >
              配种次数 {this.state.showDot && <Badge dot />}
            </List.Item>
            <List.Item
                className={cache.trnInMateGroup ? '' : 'am-list-extra-empty'}
                extra={this.state.cache.trnInMateGroup || '请选择'}
                arrow="horizontal"
                onClick={() => {
                this.setState({
                  modalShow: true,
                  modalContent: (
                    <MateGroupList
                        current={this.state.cache.trnInMateGroup}
                        data={mateGroupSource}
                        selectItem={item => {
                        this.setState(state => {
                          state.modalShow = false;
                          state.cache.trnInMateGroup = item.mateGroup;
                          return state
                        })
                      }}
                    />
                  )
                })
              }}
            >
              配种组
            </List.Item>
            {/*所在农场*/}
            <List.Item
                className={
                cache.releaseFarmOrgLoc
                  ? 'max-extra-width'
                  : 'max-extra-width am-list-extra-empty'
              }
                extra={this.state.cache.releaseFarmOrgLoc || '请选择'}
                arrow="horizontal"
              // onClick={this.getReleaseFarmOrgLoc}
                onClick={() => {
                this.setState({
                  modalShow: true,
                  modalContent: (
                    <ReleaseFarmOrgList
                        current={this.state.cache.releaseFarmOrgLoc}
                        activityType={this.state.cache.trnInActivityType}
                        selectItem={item => {
                        this.setState(state => {
                          state.modalShow = false;
                          state.cache.releaseFarmOrgLoc = item.farmOrg;
                          state.releaseLocation = item.location;
                          if (
                            state.cache.activityType === 'G' &&
                            item.location === '1'
                          ) {
                            Toast.info('配种舍状态不能是 Gilt', 3);
                            state.cache.releaseFarmOrgLoc = '';
                            state.releaseLocation = ''
                          }
                          return state
                        })
                      }}
                    />
                  )
                })
              }}
            >
              所在农场 {this.state.showDot && <Badge dot />}
            </List.Item>
            <List.Item
                className={
                cache.atbirthFarmOrgLoc
                  ? 'max-extra-width'
                  : 'max-extra-width am-list-extra-empty'
              }
                extra={cache.atbirthFarmOrgLoc || '请选择'}
                arrow="horizontal"
              // onClick={this.getAtbirthFarmOrgLoc}
                onClick={() => {
                this.setState({
                  modalShow: true,
                  modalContent: (
                    <AtBirthFarmOrgList
                        current={cache.atbirthFarmOrgLoc}
                        selectItem={item => {
                        this.setState(state => {
                          state.modalShow = false;
                          state.cache.atbirthFarmOrgLoc = item.farmOrg;
                          return state
                        })
                      }}
                    />
                  )
                })
              }}
            >
              出生农场
            </List.Item>
            <InputItem
                type="text"
                style={{ textAlign: 'right' }}
                placeholder="请输入"
                onChange={v => {
                this.setState(state => {
                  state.cache.verBreederFarmOrg = v;
                  return state
                })
              }}
            >
              后备农场
            </InputItem>
          </List>
          {/*<h4>之前状态</h4>*/}
          <List renderHeader={() => ''}>
            <List.Item>
              <b>之前状态</b>
            </List.Item>
            <List.Item
                className={cache.lastActivityType ? '' : 'am-list-extra-empty'}
                extra={this.state.cache.lastActivityType || '请选择'}
                arrow="horizontal"
              // onClick={this.getLastActivityType}
                onClick={() => {
                this.setState({
                  modalShow: true,
                  modalContent: (
                    <LastActivityTypeList
                        activityType={this.state.cache.activityType}
                        current={this.state.cache.lastActivityType}
                        selectItem={item => {
                        this.setState(state => {
                          state.modalShow = false;
                          state.cache.lastActivityType = item.gdCode;
                          state.lastActivityTypeDesc = item.descLoc;
                          if (item.gdCode === 'G') {
                            state.cache.lastLitno1 = 0;
                            state.cache.lastLitno2 = 0
                          } else {
                            state.cache.lastLitno1 = 1;
                            state.cache.lastLitno2 = 1
                          }
                          if (
                            item.gdCode === 'M' &&
                            state.cache.lastActivityDate
                          ) {
                            this.doGetMateGroup(
                              'lastMateGroup',
                              state.cache.lastActivityDate
                            )
                          }
                          return state
                        })
                      }}
                    />
                  )
                })
              }}
            >
              状态
            </List.Item>

            <DatePicker
                mode="date"
                value={
                this.state.cache.lastActivityDate &&
                new Date(this.state.cache.lastActivityDate)
              }
                onOk={date => {
                this.state.cache.lastActivityType === 'M' &&
                this.doGetMateGroup('lastMateGroup', date);
                this.setState(state => {
                  state.cache.lastActivityDate = df(date, 'yyyy-mm-dd');
                  return state
                })
              }}
            >
              <List.Item
                  arrow="horizontal"
                  className={cache.lastActivityDate ? '' : 'am-list-extra-empty'}
              >
                日期
              </List.Item>
            </DatePicker>

            <List.Item
                extra={
                <Stepper
                    style={{ width: '100%', minWidth: '100px' }}
                    showNumber
                  // max={10}
                    min={0}
                    value={this.state.cache.lastLitno1}
                    onChange={v => {
                    this.setState(state => {
                      state.cache.lastLitno1 = v;
                      return state
                    })
                  }}
                />
              }
            >
              胎次
            </List.Item>

            <List.Item
                extra={
                <Stepper
                    style={{ width: '100%', minWidth: '100px' }}
                    showNumber
                  // max={10}
                    min={0}
                    value={this.state.cache.lastLitno2}
                    onChange={v => {
                    this.setState(state => {
                      state.cache.lastLitno2 = v;
                      return state
                    })
                  }}
                />
              }
            >
              配种次数
            </List.Item>

            <List.Item
                className={cache.lastMateGroup ? '' : 'am-list-extra-empty'}
                extra={this.state.cache.lastMateGroup || '请选择'}
                arrow="horizontal"
              // onClick={this.changeMateGroup.bind(this,'lastMateGroup')}
                onClick={() => {
                this.setState({
                  modalShow: true,
                  modalContent: (
                    <MateGroupList
                        current={this.state.cache.lastMateGroup}
                        data={mateGroupSource}
                        selectItem={item => {
                        this.setState(state => {
                          state.modalShow = false;
                          state.cache.lastMateGroup = item.mateGroup;
                          return state
                        })
                      }}
                    />
                  )
                })
              }}
            >
              配种组
            </List.Item>
          </List>

          {/*<h4>调拨</h4>*/}
          <List renderHeader={() => ''}>
            <List.Item>
              <b>调拨</b>
              <List.Item.Brief>进</List.Item.Brief>
            </List.Item>

            <List.Item
                className={
                this.state.transferInOrgCodeDesc
                  ? 'max-extra-width'
                  : 'max-extra-width am-list-extra-empty'
              }
                extra={this.state.transferInOrgCodeDesc || '请选择'}
                arrow="horizontal"
                onClick={() => {
                this.setState({
                  modalShow: true,
                  modalContent: (
                    <TransferInOutOrgCodeList
                        inOrOut="in"
                        data={this.state.transferInOrgCodeData}
                        current={this.state.cache.transferInOrgCode}
                        selectItem={item => {
                        this.getTranInFarmOrg(
                          item.orgCode,
                          this.state.cache.activityType
                        );
                        this.getReleaseFarmOrg(this.state.cache.activityType);
                        this.setState(state => {
                          state.modalShow = false;
                          state.cache.transferInOrgCode = item.orgCode;
                          state.transferInOrgCodeDesc = item.orgNameLoc;
                          return state
                        })
                      }}
                    />
                  )
                })
              }}
            >
              分公司代码 {this.state.showDot && <Badge dot />}
            </List.Item>

            <DatePicker
                disabled
                mode="date"
                value={
                this.state.cache.transferInDate &&
                new Date(this.state.cache.transferInDate)
              }
                onOk={date => {
                this.setState(state => {
                  state.cache.transferInDate = df(date, 'yyyy-mm-dd');
                  return state
                })
              }}
            >
              <List.Item arrow="horizontal"
                  disabled
              >
                日期 {this.state.showDot && <Badge dot />}
              </List.Item>
            </DatePicker>

            <List.Item
                className={
                this.state.transferInFarmOrgDesc
                  ? 'max-extra-width'
                  : 'max-extra-width am-list-extra-empty'
              }
                extra={this.state.transferInFarmOrgDesc || '请选择'}
                arrow="horizontal"
                onClick={item => {
                this.setState({
                  modalShow: true,
                  modalContent: (
                    <TransferInOutFarmOrgList
                        current={this.state.cache.transferInFarmOrg}
                        orgCode={this.state.cache.transferInOrgCode}
                        data={this.state.transferInFarmOrgData}
                        selectItem={item => {
                        this.setState(state => {
                          state.modalShow = false;
                          state.cache.transferInFarmOrg = item.farmOrg;
                          state.transferInFarmOrgDesc = item.nameLoc;
                          return state
                        })
                      }}
                    />
                  )
                })
              }}
            >
              农场代码 {this.state.showDot && <Badge dot />}
            </List.Item>

            <List.Item>
              <List.Item.Brief>出</List.Item.Brief>
            </List.Item>

            <List.Item
                className={
                this.state.transferOutOrgCodeDesc
                  ? 'max-extra-width'
                  : 'max-extra-width am-list-extra-empty'
              }
                extra={this.state.transferOutOrgCodeDesc || '请选择'}
                arrow="horizontal"
                onClick={() => {
                this.setState({
                  modalShow: true,
                  modalContent: (
                    <TransferInOutOrgCodeList
                        inOrOut="out"
                        current={this.state.transferOutOrgCodeDesc}
                        selectItem={item => {
                        this.setState(state => {
                          state.modalShow = false;
                          state.cache.transferOutOrgCode = item.orgCode;
                          state.transferOutOrgCodeDesc = item.orgNameLoc;
                          return state
                        })
                      }}
                    />
                  )
                })
              }}
            >
              分公司代码
            </List.Item>

            <DatePicker
                mode="date"
                value={
                this.state.cache.transferOutDate &&
                new Date(this.state.cache.transferOutDate)
              }
                onOk={date => {
                this.setState(state => {
                  state.cache.transferOutDate = df(date, 'yyyy-mm-dd');
                  return state
                })
              }}
            >
              <List.Item
                  arrow="horizontal"
                  className={
                  cache.transferOutDate
                    ? 'max-extra-width'
                    : 'max-extra-width am-list-extra-empty'
                }
              >
                日期
              </List.Item>
            </DatePicker>

            <List.Item
                className={
                this.state.transferOutFarmOrgDesc
                  ? 'max-extra-width'
                  : 'max-extra-width am-list-extra-empty'
              }
                extra={this.state.transferOutFarmOrgDesc || '请选择'}
                arrow="horizontal"
                onClick={item => {
                this.setState({
                  modalShow: true,
                  modalContent: (
                    <TransferInOutFarmOrgList
                        current={this.state.cache.transferOutFarmOrg}
                        orgCode={this.state.cache.transferOutOrgCode}
                        selectItem={item => {
                        this.setState(state => {
                          state.modalShow = false;
                          state.cache.transferOutFarmOrg = item.farmOrg;
                          state.transferOutFarmOrgDesc = item.nameLoc;
                          return state
                        })
                      }}
                    />
                  )
                })
              }}
            >
              农场代码
            </List.Item>
          </List>

          {/*<h4>父系 && 母系</h4>*/}

          <List renderHeader={() => ''}>
            <List.Item>
              <b>父系 && 母系</b>
            </List.Item>
            <List.Item
                className={
                cache.swineDamTrack
                  ? 'max-extra-width'
                  : 'max-extra-width am-list-extra-empty'
              }
                extra={this.state.cache.swineDamTrack || '请选择'}
                arrow="horizontal"
                onClick={() => {
                this.setState({
                  modalShow: true,
                  modalContent: (
                    <SwineDamOrSireList
                        sex="F"
                        current={
                        this.state.cache.swineDamTrack +
                        this.state.cache.swineDamDateIn
                      }
                        selectItem={item => {
                        this.setState(state => {
                          state.modalShow = false;
                          state.cache.swineDamId = item.swineId;
                          state.cache.swineDamTrack = item.swineTrack;
                          state.cache.swineDamDateIn = item.swineDateIn;
                          return state
                        })
                      }}
                    />
                  )
                })
              }}
            >
              母系信息
            </List.Item>

            <InputItem
                labelNumber={6}
                disabled
                style={{ textAlign: 'right', color: '#000' }}
                value={this.state.cache.swineDamDateIn}
            >
              母系进场日期
            </InputItem>
            <List.Item
                className={
                cache.swineSirTrack
                  ? 'max-extra-width'
                  : 'max-extra-width am-list-extra-empty'
              }
                extra={this.state.cache.swineSirTrack || '请选择'}
                arrow="horizontal"
                onClick={() => {
                this.setState({
                  modalShow: true,
                  modalContent: (
                    <SwineDamOrSireList
                        sex="M"
                        current={
                        this.state.cache.swineSirTrack +
                        this.state.cache.swineSirDateIn
                      }
                        selectItem={item => {
                        this.setState(state => {
                          state.modalShow = false;
                          state.cache.swineSirId = item.swineId;
                          state.cache.swineSirTrack = item.swineTrack;
                          state.cache.swineSirDateIn = item.swineDateIn;
                          return state
                        })
                      }}
                    />
                  )
                })
              }}
            >
              父系信息
            </List.Item>
            <InputItem
                disabled
                labelNumber={6}
                style={{ textAlign: 'right', color: '#000' }}
                value={this.state.cache.swineSirDateIn}
            >
              父系进场日期
            </InputItem>
          </List>

          {/*<h4>后备信息</h4>*/}

          <List renderHeader={() => ''}>
            <List.Item>
              <b>后备信息</b>
            </List.Item>
            <InputItem
                style={{ textAlign: 'right' }}
                placeholder={'请输入'}
                value={cache.replaceFarmOrgLoc}
                arrow="horizontal"
                onChange={v => {
                this.setState(state => {
                  state.cache.replaceFarmOrgLoc = v;
                  return state
                })
              }}
            >
              后备农场
            </InputItem>

            <DatePicker
                disabled
                mode="date"
                value={
                this.state.cache.replaceDate &&
                new Date(this.state.cache.replaceDate.replace(/-/g,'/'))
              }
                onOk={date => {
                this.setState(state => {
                  state.cache.replaceDate = df(date, 'yyyy-mm-dd');
                  return state
                })
              }}
            >
              <List.Item
                  arrow="horizontal"
                  className={cache.replaceDate ? '' : 'am-list-extra-empty'}
              >
                转正日期 <Badge dot={this.state.releaseLocation === '1'} />
              </List.Item>
            </DatePicker>

            <List.Item
                extra={
                <Stepper
                    style={{ width: '100%', minWidth: '100px' }}
                    showNumber
                  // max={10}
                    min={0}
                    value={this.state.cache.replaceLitno1}
                    onChange={v => {
                    this.setState(state => {
                      state.cache.replaceLitno1 = v;
                      return state
                    })
                  }}
                />
              }
            >
              胎次
            </List.Item>

            <List.Item
                extra={
                <Stepper
                    style={{ width: '100%', minWidth: '100px' }}
                    showNumber
                  // max={10}
                    min={0}
                    value={this.state.cache.replaceLitno2}
                    onChange={v => {
                    this.setState(state => {
                      state.cache.replaceLitno2 = v;
                      return state
                    })
                  }}
                />
              }
            >
              配种次数
            </List.Item>

            <InputItem
                style={{ textAlign: 'right' }}
                placeholder={cache.replaceMateGroup || '请选择'}
                value={cache.replaceMateGroup}
                arrow="horizontal"
                onChange={v => {
                this.setState(state => {
                  state.cache.replaceMateGroup = v;
                  return state
                })
              }}
            >
              配种组
            </InputItem>
          </List>
        </Folding>
        <WhiteSpace size="xl" />
        {
          this.state.saveAble &&
          <WingBlank>
            <Button
                type="primary"
                disabled={!this.state.saveAble}
                onClick={() => {
                this.doSave(this.state.cache)
              }
              }
            >
              + 添加猪只
            </Button>
            <WhiteSpace size="xs" />
          </WingBlank>
        }
        {/* <DatePicker
            mode="date"
            maxDate={new Date()}
            minDate={new Date(auth.getMinDate())}
            value={
              this.state.date
            }
            onOk={date => {
              this.setState(state => {
                state.date = date
                state.cache.transferInDate = df(date, 'yyyy-mm-dd')
                state.cache.replaceDate = df(date, 'yyyy-mm-dd')
                return state
              })
            }}
          > */}
        <Calendar
            maxDate={new Date()}
            minDate={new Date(auth.getMinDate())}
            type="one"
            renderHeader={() => {
            return (
              <React.Fragment>
                <NavBar mode="light">日期选择</NavBar>
                <button
                    aria-label="Close"
                    onClick={this.toggleCalendar}
                    className="am-modal-close"
                >
                  <span className="am-modal-close-x" />
                </button>
              </React.Fragment>
            );
          }}
            visible={this.state.visibleCalendar}
            onConfirm={date => {
            this.setState(state => {
              state.date = date;
              state.cache.transferInDate = df(date, 'yyyy-mm-dd');
              state.cache.replaceDate = df(date, 'yyyy-mm-dd');
              state.visibleCalendar = false;
              return state
            })
          }}
            onCancel={this.toggleCalendar}
            defaultValue={[
            this.state.date
          ]}
        />

        <Modal
            closable
            popup
            onClose={() => {
            this.setState({
              modalShow: false
            })
          }}
            animationType="slide-up"
            visible={this.state.modalShow}
        >
          {this.state.modalContent}
        </Modal>
      </React.Fragment>
    )
  }
}
